<div class="content" role="main">

  <h2>Login</h2>

  <ng-container *ngIf="!environmentApiKey else access">

    <p>Please enter your API key in order to access and use the forms</p>

    <form class="forms widthMax"  (ngSubmit)="onSubmit()" >
      <mat-form-field appearance="fill">
        <mat-label>API key</mat-label>
        <input matInput placeholder="Ex. 1aa62bf9-687f-4e84-bcb3-284a1f71b81d" [formControl]="apiKeyFormControl">
        <mat-error *ngIf="error">
          {{error}}
        </mat-error>
      </mat-form-field>

      <p class="error" *ngIf="error">
        {{error}}
      </p>

      <!--  -->
      <button mat-raised-button color="accent" type="submit" [disabled]="!apiKeyFormControl.valid" >Submit</button>

    </form>

  </ng-container>
  <ng-template #access>
    <p class="title"> You can now access the different forms:</p>

    <div id="buttons">
      <button mat-raised-button color="primary" (click)="usefulFunctionsService.goTo('/products-data')">Products Data</button>
      <button mat-raised-button color="primary" (click)="usefulFunctionsService.goTo('/inci-details')">Ingredient Taxonomy</button>
      <button mat-raised-button color="primary" (click)="usefulFunctionsService.goTo('/inci-alerts')">INCI Alerts</button>
      <button mat-raised-button color="primary" (click)="usefulFunctionsService.goTo('/recommendations')">Recommendations</button>
    </div>
  </ng-template>



</div>
